import React from 'react'
import DynamicFormElements from '../Form/DynamicFormElements'

const formConfigTemplate = [
  {
    type: 'dateRange',
    isMandatoryField: true,
  },
  {
    type: 'select',
    name: 'storeHouseId',
    label: 'warehouse',
    isMandatoryField: true,
    defaultIsEmptyGuid: true,
    defaultName: 'select',
    options: []
  },
  {
    type: 'spacer',
  },
  {
    type: 'checkbox',
    name: 'showDeleted',
    label: 'stockChangesShowDeleted'
  },
  {
    type: 'spacer',
  },
  {
    type: 'articleSelect',
    name: 'articleIDs'
  },
  {
    type: 'text',
    name: 'emailAddress',
    label: 'emailAddress'
  }
]

const StockChangesStatistics = ({ formData, setFormData, formErrors }) => {



  return (
    <>
      <DynamicFormElements formConfigTemplate={formConfigTemplate} setFormData={setFormData} formData={formData} formErrors={formErrors} />
    </>
  )
}
export default StockChangesStatistics